import { render, staticRenderFns } from "./custom-table.vue?vue&type=template&id=4dcfa0f6&scoped=true&"
import script from "./custom-table.vue?vue&type=script&lang=js&"
export * from "./custom-table.vue?vue&type=script&lang=js&"
import style0 from "./custom-table.vue?vue&type=style&index=0&id=4dcfa0f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcfa0f6",
  null
  
)

export default component.exports